import { Injectable, Injector } from '@angular/core';
import { MescService } from '../mesc/mesc.service'

@Injectable()
export class TntService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt"); }
}


@Injectable()
export class ApplicationService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/Application"); }
}


@Injectable()
export class ApplicationSystemService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/Application/System"); }
}


@Injectable()
export class TntSystemService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/System"); }
}


@Injectable()
export class TntSystemCenterService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/System/Center"); }
}


@Injectable()
export class TntCenterService extends MescService {
  constructor(injector: Injector) { super(injector, "Center"); }
}


@Injectable()
export class TntToolService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/tool"); }
}


@Injectable()
export class TntToolVersionService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt"); }
}


@Injectable()
export class TntArchivedToolService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/ArchivedTools"); }
}


@Injectable()
export class TntToolOwnerService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/user"); }
}


@Injectable()
export class TntToolTypeApplicationService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/ToolType/Application"); }
}


@Injectable()
export class TntToolTypeService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/ToolType"); }
}


@Injectable()
export class TntToolReferenceFileService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/ToolReferenceFile"); }
}


@Injectable()
export class TntToolUsageService extends MescService {
  constructor(injector: Injector) { super(injector, "tnt/ToolUsage"); }
}



